import { createFileRoute } from '@tanstack/react-router';
import { IdentitySettings } from '@/components/identities';
import { PageContent } from '@/components/page-content';

export const Route = createFileRoute(
  '/_auth/_side-layout/project-settings/identity',
)({
  component: IdentitySettingsRoute,
});

function IdentitySettingsRoute() {
  return (
    <PageContent>
      <IdentitySettings />
    </PageContent>
  );
}
